export default {
  button: 'Cambiar contraseña',
  newPassword: 'Nueva contraseña',
  confirm: 'Confirmar contraseña',
  doesntMatch: 'Las contraseñas no coinciden',
  setPassword: 'Guardar contraseña'
}
